import { Theme } from '@mui/material'

const useStyles = {
  centerAlign: {
    textAlign: 'center',
  },
  logo: (theme: Theme) => ({
    margin: theme.spacing(1, 0, 2, 0),
  }),
  okBtn: (theme: Theme) => ({
    marginTop: theme.spacing(2),
  }),
}

export default useStyles
